module.exports = __webpack_public_path__ + "img/20220709_AGHSolarBoatMonacoEnergyBoatChallenge_SJanaczek_030.ca2be941.webp";